import { useState, useEffect } from 'react';
import { useDeviceDetect } from 'hooks';

export default () => {
  const { isDesktop } = useDeviceDetect();
  const [isVisibleControls, setIsVisibleControls] = useState(true);
  const [timer, setTimer] = useState(null);

  const hideControls = () => {
    const timerName = setTimeout(() => {
      setIsVisibleControls(false);
    }, 3000);
    setTimer(timerName);
  };

  const showControls = () => {
    setIsVisibleControls(true);
    if (timer) clearTimeout(timer);
    if (!isDesktop) hideControls();
  };

  useEffect(() => {
    if (isVisibleControls && !isDesktop) hideControls();
  }, [isVisibleControls]);

  return {
    isVisibleControls,
    showControls,
    hideControls,
  };
};
